import { engineComponent, NumberUtils, Utils } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Symbol } from "../GameComponents/Symbol";
import { WinAnimator } from "../GameComponents/WinAnimator";
import { Tweens } from "../Components/Effects/Tweens";
import { PlayList } from "../Components/Sounds/PlayList";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { FrameTimerEvents } from "../Utils/FrameTimer";
import { Payline } from "../GameComponents/Payline";
import { ImageElement } from "../Components/Elements/Graphics/ImageElement";
import { PaylinesDefinitions } from "../GameComponents/PaylinesDefinitions";
import { IWin } from "neo-games/Engine/Communication/Game/Types/IWin";
import { PaytableBoxElement } from "./PaytableBoxElement";
import { Settings } from "./Settings";
import { GameManager } from "../Managers/GameManager";
import { BaseView } from "../GameComponents/Base/BaseView";
import { ModuleManager } from "../Managers/ModuleManager";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { ISymbolTeasingAttributes, SymbolTeasingActions, TeasingComponentAbstract } from "./TeasingComponentAbstract";
import { BetManager } from "../Managers/BetManager";
import { DataManager } from "../Managers/DataManager";
import { ImageTextCounterElement } from "../Components/Elements/Texts/ImageTextCounterElement";
import { AppContext } from "../../Common/AppContext";
import { Symbols } from "../GameComponents/Symbols";
import { Paylines } from "../GameComponents/Paylines";
import { CustomUtils } from "../Utils/CustomUtils";
import { ImageTextElement } from "../Components/Elements/Texts/ImageTextElement";
import { StageController } from "../Components/StageController";

export enum ReelsHighlightOptions {
    hide = 0, //- turn off highlight vith visible = false
    loop = 1, //- highlight in loop
    show_slow = 2, // - highlight with tween, no loop
    show_fast = 3, // - highlight, with visible = true
}

@engineComponent(ComponentTypes.DisplayObject)
export class WinAnimatorExtended extends WinAnimator {
    //******************************************************************************************************************
    //  TIMER STATUSES
    //******************************************************************************************************************

    protected static readonly ShowFirstWins: string = "showFirstWins";
    protected static readonly CycleWins1: string = "cycleWins1";
    protected static readonly FinishWinAnimatorTimer: string = "finishWinAnimatorTimer";
    protected static readonly StartAnimationTimer: string = "startAnimationTimer";
    protected static readonly MysteryDrawTimer: string = "mysteryDrawTimer";
    protected static readonly BigXDrawTimer: string = "bigXDrawTimer";

    protected static readonly ShowFirstWinsStep1 = "showFirstWinsStep1";
    protected static readonly ShowFirstWinsStep2 = "showFirstWinsStep2";
    protected static readonly ShowFirstWinsStep3 = "showFirstWinsStep3";
    protected static readonly ShowFirstWinsStep4 = "showFirstWinsStep4";

    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    protected elementInstance: Array<Object> = [];
    public reelsContaier: SwitchElement;
    public paytableBoxElement: PaytableBoxElement;
    public stickyContainer: ContainerElement;
    public currentStickySymbols: Symbol[][] = [];
    protected teasedSymbolsContainer: ContainerElement;

    protected counter: ContainerElement;
    protected winCounter: ImageTextCounterElement;
    protected currentCounterStep: number;

    private _spinButton: Element;

    protected bigXSymbolsCounter = 0;

    //******************************************************************************************************************
    //  CREATE, INITIALIZE
    //******************************************************************************************************************

    public initialize(
        symbols: Symbols,
        paylines?: Paylines,
        noWinSymbolsContainer?: ContainerElement,
        symbolsContainer?: ContainerElement,
    ): void {
        super.initialize(symbols, paylines, noWinSymbolsContainer, symbolsContainer);

        this.currentStickySymbols = [];

        for (let reelIndex = 0; reelIndex < this.reelCount; reelIndex++) {
            this.currentStickySymbols[reelIndex] = [];

            for (let symbolIndex = 0; symbolIndex < this.symbolCount; symbolIndex++) {
                this.currentStickySymbols[reelIndex][symbolIndex] = null;
            }
        }

        this.createCounter();

        //this._spinButton = document.getElementsByClassName('#userControls .spinBtn')[0];
    }

    //******************************************************************************************************************
    //  ON REEL STOPPED, SHOW SYMBOLS
    //******************************************************************************************************************

    public onReelStopped(reelsData: Array<Communication.Game.IReel>, reelIndex: number, force = false): void {
        super.onReelStopped(reelsData, reelIndex);

        this.setSymbolsCasesByTeasingAttributes(force, reelIndex);

        this.impactSpecialSymbols(reelsData, reelIndex);
    }

    protected setSymbolsCasesByTeasingAttributes(force: boolean, reelIndex: number) {
        if (!force) {
            if (this.elementInstance["teasing"] != null) {
                let sta: Array<Array<ISymbolTeasingAttributes>>;

                this.elementInstance["teasing"].forEach(function (teasingComponent: TeasingComponentAbstract) {
                    let symbolsTeasingAttributes = teasingComponent.setSymbolsTeasingAttributes(reelIndex);
                    if (teasingComponent.teasingEnabled) {
                        sta = symbolsTeasingAttributes;
                    }
                }, this);

                for (let i = 0; i < this.reelCount; i++) {
                    for (let j = 0; j < this.currentSymbols[i].length; j++) {
                        let currentSymbol = this.currentSymbols[i][j];
                        if (currentSymbol != null) {
                            if (typeof sta !== "undefined") {
                                if (sta[i][j].action === SymbolTeasingActions.NOWIN) {
                                    if (this.allowSymbolGoToCase(i, j, Symbol.CaseNowin)) {
                                        currentSymbol.goToCase(Symbol.CaseNowin);
                                    }
                                } else if (sta[i][j].action === SymbolTeasingActions.NORMAL) {
                                    if (this.allowSymbolGoToCase(i, j, Symbol.CaseNormal)) {
                                        currentSymbol.goToCase(Symbol.CaseNormal);
                                    }
                                } else if (sta[i][j].action === SymbolTeasingActions.IMPACT) {
                                    if (this.allowSymbolGoToCase(i, j, Symbol.CaseImpact)) {
                                        currentSymbol.goToCase(Symbol.CaseImpact);
                                    }
                                } else if (sta[i][j].action === SymbolTeasingActions.TEASE) {
                                    if (this.allowSymbolGoToCase(i, j, Symbol.CaseTease)) {
                                        currentSymbol.goToCase(Symbol.CaseTease);
                                    }
                                } else if (sta[i][j].action === SymbolTeasingActions.IMPACT_TEASE) {
                                    if (this.allowSymbolGoToCase(i, j, Symbol.CaseImpactTease)) {
                                        currentSymbol.goToCase(Symbol.CaseImpactTease);
                                    }
                                } else if (sta[i][j].action === SymbolTeasingActions.IMPACT_WIN) {
                                } else if (sta[i][j].action === SymbolTeasingActions.EMPTY) {
                                    if (this.allowSymbolGoToCase(i, j, Symbol.CaseEmpty)) {
                                        currentSymbol.goToCase(Symbol.CaseEmpty);
                                    }
                                }
                            } else {
                                if (this.allowSymbolGoToCase(i, j, Symbol.CaseImpact)) {
                                    if (
                                        currentSymbol.id === Settings.SymbolBigXSpins ||
                                        currentSymbol.id === Settings.SymbolMystery
                                    ) {
                                        if (reelIndex == 0 && i == 0) {
                                            currentSymbol.goToCase(Symbol.CaseImpact);
                                        }
                                    } else {
                                    }
                                }
                            }
                        }
                    }
                }
            } else {
                for (let i = 0; i < this.reelCount; i++) {
                    for (let j = 0; j < this.currentSymbols[i].length; j++) {
                        let currentSymbol = this.currentSymbols[i][j];
                        if (currentSymbol != null) {
                            if (this.allowSymbolGoToCase(i, j, Symbol.CaseImpact)) {
                                //if (Object.keys(Settings.SymbolWildsMatrix).filter(key => Settings.SymbolWildsMatrix[key] === currentSymbol.id, this).length > 0) {
                                currentSymbol.goToCase(Symbol.CaseImpact);
                                //}
                            }
                        }
                    }
                }
            }
        } else {
            for (let i = 0; i < this.reelCount; i++) {
                for (let j = 0; j < this.currentSymbols[i].length; j++) {
                    let currentSymbol = this.currentSymbols[i][j];
                    if (currentSymbol != null) {
                        if (this.allowSymbolGoToCase(i, j, Symbol.CaseImpact)) {
                            //if (Object.keys(Settings.SymbolWildsMatrix).filter(key => Settings.SymbolWildsMatrix[key] === currentSymbol.id, this).length > 0) {
                            currentSymbol.goToCase(Symbol.CaseImpact);
                            //}
                        }
                    }
                }
            }
        }
    }

    private impactSpecialSymbols(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        this.impactBigX(reelsData, reelIndex);
        this.impactScatter(reelsData, reelIndex);
    }

    protected tease(reelIndex: number): void {
        const count = this.countScatters(reelIndex);

        if (count >= this.getMinTeasingSymbolCount()) {
            this.tease3(reelIndex, count);
        } else if (count === this.getMinTeasingSymbolCount() - 1) {
            this.tease2(reelIndex, count);
        } else {
            this.tease1(reelIndex, count);
        }
    }

    protected countScatters(reelIndex: number): number {
        let count = 0;

        for (let i = 0; i <= reelIndex; i++) {
            if (this.currentReels[i].symbols.indexOf(this.getTeasingSymbol()) !== -1) {
                count++;
            }
        }

        return count;
    }

    protected tease1(reelIndex: number, count: number): void {
        if (this.reelCount - reelIndex - 1 < this.getMinTeasingSymbolCount() - count) {
            return;
        }

        const symbolIndex = this.currentReels[reelIndex].symbols.indexOf(this.getTeasingSymbol());

        if (symbolIndex !== -1) {
            if (this.allowSymbolGoToCase(reelIndex, symbolIndex, Symbol.CaseImpact)) {
                this.currentSymbols[reelIndex][symbolIndex].goToCase(Symbol.CaseImpact);
            }
        }
    }

    protected tease2(reelIndex: number, count: number): void {
        if (this.reelCount - reelIndex - 1 < this.getMinTeasingSymbolCount() - count) {
            for (let i = 0; i < reelIndex; i++) {
                for (let j = 0; j < this.currentSymbols[i].length; j++) {
                    if (this.allowSymbolGoToCase(i, j, Symbol.CaseNormal)) {
                        this.currentSymbols[i][j].goToCase(Symbol.CaseNormal);
                    }
                }
            }

            return;
        }

        for (let i = 0; i < reelIndex; i++) {
            for (let j = 0; j < this.currentSymbols[i].length; j++) {
                if (this.currentSymbols[i][j].id === this.getTeasingSymbol() - 1) {
                    if (this.allowSymbolGoToCase(i, j, Symbol.CaseTease)) {
                        this.currentSymbols[i][j].goToCase(Symbol.CaseTease);
                    }
                }
            }
        }

        this.tease3(reelIndex, count);
    }

    protected tease3(reelIndex: number, count: number): void {
        for (let i = 0; i < this.currentSymbols[reelIndex].length; i++) {
            if (this.currentSymbols[reelIndex][i].id === this.getTeasingSymbol() - 1) {
                if (this.allowSymbolGoToCase(reelIndex, i, Symbol.CaseTease)) {
                    this.currentSymbols[reelIndex][i].goToCase(Symbol.CaseTease);
                }
            }
        }
    }

    protected getTeasingSymbol(): number {
        return 12;
    }

    protected getMinTeasingSymbolCount(): number {
        return 3;
    }

    private impactBigX(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        if (reelsData[reelIndex] != null && reelsData[reelIndex].symbols != null) {
            for (let symbolIndex = 0; symbolIndex < reelsData[reelIndex].symbols.length; symbolIndex++) {
                if (reelsData[reelIndex].symbols[symbolIndex] === Settings.SymbolBigXSpins) {
                    if (this.currentStickySymbols[reelIndex][symbolIndex] == null) {
                        if (CustomUtils.isRespinEnabled()) {
                            this.bigXSymbolsCounter = 0;
                            PlayList.play("SND_BigXHit0" + (this.bigXSymbolsCounter + 1));
                            PlayList.play("SND_BigXIn");

                            if (!Utils.isNullOrUndefined(BaseView.Logo)) {
                                BaseView.Logo.goToCase("BLICK");
                            }

                            if (!Utils.isNullOrUndefined(BaseView.XBox)) {
                                let children: Object = BaseView.XBox.getAllChildElements();

                                let frameGlow: ImageElement = null;
                                if (<ImageElement>children["FrameGlow"].visible) {
                                    frameGlow = <ImageElement>children["FrameGlow"];
                                } else if (<ImageElement>children["FrameGlowPortrait"].visible) {
                                    frameGlow = <ImageElement>children["FrameGlowPortrait"];
                                }

                                if (!Utils.isNullOrUndefined(frameGlow)) {
                                    Tweens.removeTweens(frameGlow, "all");
                                    Tweens.customTween(frameGlow, {
                                        tween: "alpha",
                                        tweenValues: [0, 1, 1, 0, 0],
                                        tweenDuration: [2, 13, 2, 13],
                                        tweenLoop: false,
                                    });
                                }
                            }

                            if (!Utils.isNullOrUndefined(BaseView.ReflectionX)) {
                                Tweens.removeTweens(BaseView.ReflectionX, "all");
                                Tweens.customTween(BaseView.ReflectionX, {
                                    tween: "scale.x",
                                    tweenValues: [BaseView.ReflectionX.scale.x + 0.3, BaseView.ReflectionX.scale.x],
                                    tweenDuration: [60],
                                    tweenEase: ["bounceOut"],
                                    tweenLoop: false,
                                });
                                Tweens.customTween(BaseView.ReflectionX, {
                                    tween: "scale.y",
                                    tweenValues: [BaseView.ReflectionX.scale.y + 0.3, BaseView.ReflectionX.scale.y],
                                    tweenDuration: [60],
                                    tweenEase: ["bounceOut"],
                                    tweenLoop: false,
                                });
                            }

                            if (!Utils.isNullOrUndefined(BaseView.ReflectionXGlow)) {
                                Tweens.removeTweens(BaseView.ReflectionXGlow, "all");
                                Tweens.customTween(BaseView.ReflectionXGlow, {
                                    tween: "alpha",
                                    tweenValues: [1, 0, 1, 0, 1, 1, 0],
                                    tweenDuration: [60],
                                    tweenLoop: false,
                                });
                                Tweens.customTween(BaseView.ReflectionXGlow, {
                                    tween: "scale.x",
                                    tweenValues: [
                                        BaseView.ReflectionXGlow.scale.x + 0.3,
                                        BaseView.ReflectionXGlow.scale.x,
                                    ],
                                    tweenDuration: [60],
                                    tweenEase: ["bounceOut"],
                                    tweenLoop: false,
                                });
                                Tweens.customTween(BaseView.ReflectionXGlow, {
                                    tween: "scale.y",
                                    tweenValues: [
                                        BaseView.ReflectionXGlow.scale.y + 0.3,
                                        BaseView.ReflectionXGlow.scale.y,
                                    ],
                                    tweenDuration: [60],
                                    tweenEase: ["bounceOut"],
                                    tweenLoop: false,
                                });
                            }
                        } else if (CustomUtils.isRespinActive()) {
                            this.bigXSymbolsCounter++;
                            PlayList.play("SND_BigXHit0" + (this.bigXSymbolsCounter + 1));

                            if (!Utils.isNullOrUndefined(BaseView.XBox)) {
                                let children: Object = BaseView.XBox.getAllChildElements();

                                let frameGlow: ImageElement = null;
                                if (<ImageElement>children["FrameGlow"].visible) {
                                    frameGlow = <ImageElement>children["FrameGlow"];
                                } else if (<ImageElement>children["FrameGlowPortrait"].visible) {
                                    frameGlow = <ImageElement>children["FrameGlowPortrait"];
                                }

                                if (!Utils.isNullOrUndefined(frameGlow)) {
                                    Tweens.removeTweens(frameGlow, "all");
                                    Tweens.customTween(frameGlow, {
                                        tween: "alpha",
                                        tweenValues: [0, 1, 1, 0, 0],
                                        tweenDuration: [2, 13, 2, 13],
                                        tweenLoop: false,
                                    });
                                }
                            }
                        } else if (CustomUtils.isRespinLast()) {
                            this.bigXSymbolsCounter++;
                            PlayList.play("SND_BigXHit0" + (this.bigXSymbolsCounter + 1));
                            this.bigXSymbolsCounter = 0;
                        } else {
                            if (this.currentSymbols[reelIndex][symbolIndex] != null) {
                                this.currentSymbols[reelIndex][symbolIndex].goToCase("IMPACT");
                            }

                            PlayList.play("SND_BigXHit01_short");
                            this.bigXSymbolsCounter = 0;
                        }
                    }
                }
            }
        }
    }

    private impactScatter(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        if (reelsData[reelIndex] != null && reelsData[reelIndex].symbols != null) {
            for (let symbolIndex = 0; symbolIndex < reelsData[reelIndex].symbols.length; symbolIndex++) {
                if (reelsData[reelIndex].symbols[symbolIndex] === Settings.SymbolMystery) {
                    if (this.currentSymbols[reelIndex][symbolIndex] != null) {
                        PlayList.play("SND_BaseMysteryHit" + reelIndex);
                    }
                }
            }
        }
    }

    //******************************************************************************************************************
    //  SHOW WINS
    //******************************************************************************************************************

    public showWins(wins: Array<Communication.Game.IWin>, win: number): boolean {
        this.resetCounter();

        this.currentWins = wins;
        this.currentWin = win;

        this.resetAnimations();

        if (wins != null && wins.length > 0) {
            this.currentMultiplierIndex = 0;

            for (let i = 0; i < this.multipliers.length; i++) {
                if (this.currentWin / BetManager.Bet >= this.multipliers[i]) {
                    this.currentMultiplierIndex = i;
                }
            }

            if (!this.showCustomWin()) {
                this.showFirstWins();
            }

            return this.currentMultiplierIndex >= 3;
        } else {
            this.allSymbolsGoToCase(Symbol.CaseNormal, false);

            this.startTimer(WinAnimator.Idle, this.getInitialIdleDelay());

            return false;
        }
    }

    protected showFirstWins(): void {
        if (!Utils.isNullOrUndefined(this.paytableBoxElement)) {
            this.paytableBoxElement.reset(true);
        }

        this.allSymbolsGoToCase(Symbol.CaseNowin, true);
        this.allPaylinesGoToCase(Payline.CaseNowin);

        let hasCashWin: boolean = false;
        let hasMysteryWin: boolean = false;

        for (let i = 0; i < this.currentWins.length; i++) {
            this.winSymbolsGoToCase(i, Symbol.CaseWin, false);
            this.winPaylineGoToCase(i, Payline.CaseFirstWin);

            if (this.currentWins[i].trigger === Communication.Game.WinTrigger.Payline) {
                if (this.currentWins[i].type == Communication.Game.WinType.Cash) {
                    hasCashWin = true;
                }
            } else if (this.currentWins[i].trigger === Communication.Game.WinTrigger.Scatter) {
                if (this.currentWins[i].type == Communication.Game.WinType.Cash) {
                    hasCashWin = true;
                } else if (this.currentWins[i].type.toString() == "mystery") {
                    hasMysteryWin = true;
                }
            }
        }

        if (hasCashWin) {
            this.startAnimation();
        } else if (hasMysteryWin) {
            if (GameManager.baseResponse != null && GameManager.baseResponse.hasOwnProperty("customData")) {
                if (GameManager.baseResponse.customData.hasOwnProperty("mysterySymbol")) {
                    let mysterySymbol = GameManager.baseResponse.customData.mysterySymbol;

                    BaseView.paytableBoxElement.reset(true);
                    BaseView.paytableBoxElement.draw();
                    BaseView.paytableBoxElement.stopDrawAfterTime(mysterySymbol - 1, 150);
                    BaseView.paytableBoxElement.customTimer.on(
                        FrameTimerEvents.Complete,
                        this.startAnimation.bind(this),
                    ); //todo ON of ONCE?
                }
            }
        } else {
            this.startTimer(WinAnimatorExtended.FinishWinAnimatorTimer, 60);
        }
    }

    protected showCustomWin(): boolean {
        if (!Utils.isNullOrUndefined(BaseView.Reels)) {
            BaseView.Reels.goToCase("WIN");
        }

        let hasCashWin = this.hasCashWin(this.currentWins);
        let hasMysteryWin = this.hasMysteryWin(this.currentWins);
        let hasBigXWin = this.hasBigXWin();

        if (hasMysteryWin) {
            if (!Utils.isNullOrUndefined(BaseView.Background)) {
                BaseView.Background.goToCase("MYSTERY");
            }

            ModuleManager.disableGamble();
            if (!DataManager.Autoplay) {
                ModuleManager.disableBase();
            }
        }

        if (hasBigXWin) {
            this.allSymbolsGoToCase(Symbol.CaseNowin, true);

            for (let i = 0; i < this.currentWins.length; i++) {
                this.winPaylineGoToCase(i, Payline.CaseFirstWin); // todo ???
                this.winSymbolsGoToCase(i, Symbol.CaseWin, false);
            }

            ModuleManager.disableGamble();
            if (!DataManager.Autoplay) {
                ModuleManager.disableBase();
            }

            if (!Utils.isNullOrUndefined(BaseView.paytableBoxElement)) {
                BaseView.paytableBoxElement.reset({
                    symbolsOn: false,
                    symbolsNoWinOn: true,
                    symbolsGlowOff: true,
                    multipliersGlowOff: true,
                });
                BaseView.paytableBoxElement.paytableBox.goToCase(PaytableBoxElement.CaseDefault);

                let symbols = BaseView.paytableBoxElement.paytableBox.getChildElementByName(
                    "Symbols",
                ) as ContainerElement;
                if (!Utils.isNullOrUndefined(symbols)) {
                    for (let i = 0; i < symbols.children.length; i++) {
                        BaseView.paytableBoxElement.chooseMultiplier(i, true);
                        BaseView.paytableBoxElement.chooseSymbol(i, true);
                    }
                }
            }

            this.startTimer(WinAnimatorExtended.BigXDrawTimer, 120);
        } else if (hasCashWin) {
            if (!Utils.isNullOrUndefined(BaseView.paytableBoxElement)) {
                BaseView.paytableBoxElement.reset({
                    symbolsOn: false,
                    symbolsNoWinOn: true,
                    symbolsGlowOff: true,
                    multipliersGlowOff: true,
                });
            }

            this.currentCounterStep = 0;

            this.startTimer(WinAnimatorExtended.ShowFirstWinsStep1, 15);
        } else if (hasMysteryWin) {
            if (!Utils.isNullOrUndefined(BaseView.Background)) {
                BaseView.Background.goToCase("MYSTERY");
            }

            if (!Utils.isNullOrUndefined(BaseView.paytableBoxElement)) {
                BaseView.paytableBoxElement.reset({
                    symbolsOn: false,
                    symbolsNoWinOn: true,
                    symbolsGlowOff: true,
                    multipliersGlowOff: true,
                });
            }

            this.allPaylinesGoToCase(Payline.CaseNowin);
            this.allSymbolsGoToCase(Symbol.CaseNowin, true);

            for (let i = 0; i < this.currentWins.length; i++) {
                this.winPaylineGoToCase(i, Payline.CaseFirstWin);
                this.winSymbolsGoToCase(i, Symbol.CaseWin, false);
            }

            this.highlightPositionsOnReels("WIN", ReelsHighlightOptions.loop);

            if (GameManager.baseResponse != null && GameManager.baseResponse.hasOwnProperty("customData")) {
                if (GameManager.baseResponse.customData.hasOwnProperty("mysterySymbol")) {
                    ModuleManager.disableGamble();
                    if (!DataManager.Autoplay) {
                        ModuleManager.disableBase();
                    }

                    if (!Utils.isNullOrUndefined(BaseView.paytableBoxElement)) {
                        BaseView.paytableBoxElement.reset({
                            symbolsOn: false,
                            symbolsNoWinOn: true,
                            symbolsGlowOff: true,
                            multipliersGlowOff: true,
                        });
                        BaseView.paytableBoxElement.paytableBox.goToCase(PaytableBoxElement.CaseMystery);

                        let symbols = BaseView.paytableBoxElement.paytableBox.getChildElementByName(
                            "Symbols",
                        ) as ContainerElement;
                        if (!Utils.isNullOrUndefined(symbols)) {
                            for (let i = 0; i < symbols.children.length; i++) {
                                BaseView.paytableBoxElement.chooseMultiplier(i, true);
                                BaseView.paytableBoxElement.chooseSymbol(i, true);
                            }
                        }
                    }

                    this.startTimer(WinAnimatorExtended.MysteryDrawTimer, 120);
                }
            }
        } else {
            if (!Utils.isNullOrUndefined(BaseView.paytableBoxElement)) {
                BaseView.paytableBoxElement.reset({
                    symbolsOn: true,
                    symbolsNoWinOn: true,
                    symbolsGlowOff: true,
                    multipliersGlowOff: true,
                });
            }

            if (!Utils.isNullOrUndefined(BaseView.Logo)) {
                BaseView.Logo.goToCase("FS_WIN");
            }

            this.allPaylinesGoToCase(Payline.CaseNowin);
            this.allSymbolsGoToCase(Symbol.CaseNowin, true);

            for (let i = 0; i < this.currentWins.length; i++) {
                this.winPaylineGoToCase(i, Payline.CaseWin);
                this.winSymbolsGoToCase(i, Symbol.CaseWin, false);
            }

            this.currentCounterStep = 0;

            this.startTimer(WinAnimatorExtended.ShowFirstWinsStep1, 60);
        }

        return true;
    }

    protected mysteryDraw(): void {
        if (GameManager.baseResponse != null && GameManager.baseResponse.hasOwnProperty("customData")) {
            if (GameManager.baseResponse.customData.hasOwnProperty("mysterySymbol")) {
                let mysterySymbol = GameManager.baseResponse.customData.mysterySymbol;

                this.addMysterySymbolsToWinCase();

                this.highlightPositionsOnReels(null, ReelsHighlightOptions.show_fast);

                if (!Utils.isNullOrUndefined(BaseView.paytableBoxElement)) {
                    BaseView.paytableBoxElement.stopDrawAfterTime(mysterySymbol - 1, 4 * 60);
                    BaseView.paytableBoxElement.draw();
                    BaseView.paytableBoxElement.customTimer.once(
                        FrameTimerEvents.Complete,
                        this.startAnimation.bind(this),
                    );
                }
            }
        }
    }

    protected bigXDraw(): void {
        if (GameManager.baseResponse != null && GameManager.baseResponse.hasOwnProperty("customData")) {
            if (GameManager.baseResponse.customData.hasOwnProperty("bigXFeaturePayout")) {
                let bigXSymbol = GameManager.baseResponse.customData.bigXFeaturePayout;
                if (!Utils.isNullOrUndefined(BaseView.paytableBoxElement)) {
                    BaseView.paytableBoxElement.stopDrawAfterTime(bigXSymbol - 1, 4 * 60);
                    BaseView.paytableBoxElement.draw();
                    BaseView.paytableBoxElement.customTimer.once(
                        FrameTimerEvents.Complete,
                        this.startAnimation.bind(this),
                    );
                }
            }
        }

        if (!Utils.isNullOrUndefined(BaseView.Logo)) {
            BaseView.Logo.goToCase("TEASE");
        }
    }

    /**
     * Step 1: prejde postupne vsetky vyhry, nastavi symboly do WIN stavu a pripocitava vyhry do Counter-u
     */
    protected showFirstWinsStep1(): void {
        let currentCounterStep = Math.floor(this.currentCounterStep);
        const win = this.currentWins[currentCounterStep];

        this.allPaylinesGoToCase(Payline.CaseNowin);
        this.allSymbolsGoToCase(Symbol.CaseNowin, true);

        for (let i = 0; i < this.currentWins.length; i++) {
            this.winPaylineGoToCase(i, Payline.CaseNormal);
            this.winSymbolsGoToCase(i, Symbol.CaseNormal, false);
        }

        if (this.isMysteryWin(win)) {
            this.winSymbolsGoToCase(currentCounterStep, Symbol.CaseQuickWin, false);
        } else {
            this.winPaylineGoToCase(currentCounterStep, Payline.CaseWin);
            this.winSymbolsGoToCase(currentCounterStep, Symbol.CaseQuickWin, false);
            this.runCounterStep1();
        }

        if (this.isMysteryWin(win)) {
            this.currentCounterStep++;
        } else {
            this.currentCounterStep++;
        }

        let timerStatus: string;
        if (Math.floor(this.currentCounterStep) < this.currentWins.length) {
            timerStatus = WinAnimatorExtended.ShowFirstWinsStep1;
        } else {
            timerStatus = WinAnimatorExtended.ShowFirstWinsStep2;
        }

        let timerDuration = 30;

        this.startTimer(timerStatus, timerDuration);
    }

    /**
     * Step 2: nastavi naraz vsetky vyhry do WIN stavu. Popne Counter cislom.
     */
    protected showFirstWinsStep2(): void {
        this.currentCounterStep = null;

        this.allPaylinesGoToCase(Payline.CaseNowin);

        for (let i = 0; i < this.currentWins.length; i++) {
            this.winPaylineGoToCase(i, Payline.CaseWin);
            this.winSymbolsGoToCase(i, Symbol.CaseWin, false);
        }

        let hasMysteryWin = this.hasMysteryWin(this.currentWins);
        if (hasMysteryWin) {
            this.highlightPositionsOnReels("WIN", ReelsHighlightOptions.loop);

            if (GameManager.baseResponse != null && GameManager.baseResponse.hasOwnProperty("customData")) {
                if (GameManager.baseResponse.customData.hasOwnProperty("mysterySymbol")) {
                    Tweens.removeTweens(this.counter, "all");
                    Tweens.alphaTween(this.counter, {
                        alphas: [1, 0],
                        tweenDuration: 30,
                    });

                    ModuleManager.disableGamble();
                    if (!DataManager.Autoplay) {
                        ModuleManager.disableBase();
                    }

                    if (!Utils.isNullOrUndefined(BaseView.paytableBoxElement)) {
                        BaseView.paytableBoxElement.reset({
                            symbolsOn: false,
                            symbolsNoWinOn: true,
                            symbolsGlowOff: true,
                            multipliersGlowOff: true,
                        });
                        BaseView.paytableBoxElement.paytableBox.goToCase(PaytableBoxElement.CaseMystery);

                        let symbols = BaseView.paytableBoxElement.paytableBox.getChildElementByName(
                            "Symbols",
                        ) as ContainerElement;
                        if (!Utils.isNullOrUndefined(symbols)) {
                            for (let i = 0; i < symbols.children.length; i++) {
                                BaseView.paytableBoxElement.chooseMultiplier(i, true);
                                BaseView.paytableBoxElement.chooseSymbol(i, true);
                            }
                        }
                    }

                    this.startTimer(WinAnimatorExtended.MysteryDrawTimer, 120);
                }
            }
        } else {
            this.runCounterStep2();

            this.startTimer(WinAnimatorExtended.ShowFirstWinsStep3, 90);

            //this.emit(WinAnimator.FinishWinCalculation); // Moved to showFirstWinsStep3 method.
        }
    }

    /**
     * Step 3: odchod Counter cisla zo screenu.
     */
    protected showFirstWinsStep3(): void {
        this.runCounterStep3();

        this.startTimer(WinAnimatorExtended.ShowFirstWinsStep4, 30);

        this.emit(WinAnimator.FinishWinCalculation);
    }

    /**
     * STep 4: Finish win animator + cycle wins.
     */
    protected showFirstWinsStep4(): void {
        this.emit(WinAnimator.FinishWinAnimator);

        this.currentCycle = 0;

        this.cycleWins();
    }

    protected cycleCashWins(): void {
        if (this.currentWins == null) {
            return;
        } else if (this.currentWins.length === 1) {
            this.allPaylinesGoToCase(Payline.CaseNowin);

            for (let i = 0; i < this.currentWins.length; i++) {
                this.winPaylineGoToCase(i, Payline.CaseNormal);
            }

            this.winSymbolsGoToCase(this.currentCycle, Symbol.CaseWin, false);
            this.winPaylineGoToCase(this.currentCycle, Payline.CaseFirstWin);

            this.startTimer(WinAnimatorExtended.ShowFirstWins, 20);
        } else {
            this.allPaylinesGoToCase(Payline.CaseNowin);

            for (let i = 0; i < this.currentWins.length; i++) {
                this.winSymbolsGoToCase(i, Symbol.CaseNormal, false);
                this.winPaylineGoToCase(i, Payline.CaseNormal);
            }

            this.winSymbolsGoToCase(this.currentCycle, Symbol.CaseWin, false); //todo Use CaseWin or CaseCycle?
            this.winPaylineGoToCase(this.currentCycle, Payline.CaseCycle);

            this.currentCycle += 1;

            this.stopTimer();
            if (this.currentCycle < this.currentWins.length) {
                this.startTimer(WinAnimatorExtended.CycleWins1, 20); //this.getCycleWinsDelay()
            } else {
                this.startTimer(WinAnimatorExtended.ShowFirstWins, 20);
            }
        }
    }

    protected showFirstInitWins(): void {
        if (CustomUtils.isRespinLast()) {
            this.allSymbolsGoToCase(Symbol.CaseNowin, true);

            for (let i = 0; i < this.currentWins.length; i++) {
                this.winSymbolsGoToCase(i, Symbol.CaseWin, false);
            }
        } else {
            this.allSymbolsGoToCase(Symbol.CaseNowin, true);
            this.allPaylinesGoToCase(Payline.CaseNowin);

            for (let i = 0; i < this.currentWins.length; i++) {
                this.winSymbolsGoToCase(i, Symbol.CaseWin, false);
                this.winPaylineGoToCase(i, Payline.CaseFirstWin);
            }
        }

        let hasMysteryWin = this.hasMysteryWin(this.currentWins);
        let hasBigXWin = this.hasBigXWin();

        if (hasMysteryWin) {
            if (GameManager.baseResponse != null && GameManager.baseResponse.hasOwnProperty("customData")) {
                if (GameManager.baseResponse.customData.hasOwnProperty("mysterySymbol")) {
                    let mysterySymbol = GameManager.baseResponse.customData.mysterySymbol;

                    if (!Utils.isNullOrUndefined(BaseView.paytableBoxElement)) {
                        BaseView.paytableBoxElement.reset({
                            symbolsOn: false,
                            symbolsNoWinOn: true,
                            symbolsGlowOff: true,
                            multipliersGlowOff: true,
                        });
                        BaseView.paytableBoxElement.paytableBox.goToCase(PaytableBoxElement.CaseMystery);
                        BaseView.paytableBoxElement.chooseMultiplier(mysterySymbol - 1, true);
                        BaseView.paytableBoxElement.chooseSymbol(mysterySymbol - 1, true);
                    }
                }
            }
        } else if (hasBigXWin) {
            if (GameManager.baseResponse != null && GameManager.baseResponse.hasOwnProperty("customData")) {
                if (GameManager.baseResponse.customData.hasOwnProperty("bigXFeaturePayout")) {
                    let bigXSymbol = GameManager.baseResponse.customData.bigXFeaturePayout;

                    if (!Utils.isNullOrUndefined(BaseView.paytableBoxElement)) {
                        BaseView.paytableBoxElement.reset({
                            symbolsOn: false,
                            symbolsNoWinOn: true,
                            symbolsGlowOff: true,
                            multipliersGlowOff: true,
                        });
                        BaseView.paytableBoxElement.paytableBox.goToCase(PaytableBoxElement.CaseDefault);
                        BaseView.paytableBoxElement.chooseMultiplier(bigXSymbol - 1, true);
                        BaseView.paytableBoxElement.chooseSymbol(bigXSymbol - 1, true);
                    }
                }
            }
        }
    }

    //******************************************************************************************************************
    //  CYCLE WINS
    //******************************************************************************************************************

    protected cycleWins(): void {
        let hasMysteryWin = this.hasMysteryWin(this.currentWins);
        let hasBigXWin = this.hasBigXWin();
        let hasCashWin = this.hasCashWin(this.currentWins);

        if (this.currentWins == null) {
            return;
        } else if (hasMysteryWin && !hasCashWin) {
            this.winPaylineGoToCase(0, Payline.CaseFirstWin);
            this.winSymbolsGoToCase(0, Symbol.CaseSingleWin, false);

            return;
        } else if (hasBigXWin) {
            PlayList.stop("SND_RespinLoop", 30);

            for (let i = 0; i < this.currentWins.length; i++) {
                this.winSymbolsGoToCase(i, Symbol.CaseWin, false);
            }

            return;
        } else if (this.currentWins.length === 1) {
            this.allPaylinesGoToCase(Payline.CaseNowin);

            this.winPaylineGoToCase(this.currentCycle, Payline.CaseFirstWin);
            this.winSymbolsGoToCase(this.currentCycle, Symbol.CaseSingleWin, true);
        } else {
            PlayList.play("SND_BaseRecapWinline");

            this.allPaylinesGoToCase(Payline.CaseNowin);

            for (let i = 0; i < this.currentWins.length; i++) {
                this.winSymbolsGoToCase(i, Symbol.CaseNormal, false);
                this.winPaylineGoToCase(i, Payline.CaseNormal);
            }

            this.winSymbolsGoToCase(this.currentCycle, Symbol.CaseCycle, true);
            this.winPaylineGoToCase(this.currentCycle, Payline.CaseCycle);

            this.currentCycle = (this.currentCycle + 1) % this.currentWins.length;

            this.stopTimer();
            this.startTimer(WinAnimator.CycleWins, this.getCycleWinsDelay());
        }
    }

    protected getCycleWinsDelay(): number {
        return 120;
    }

    reset(showLastSymbols: boolean, spin: boolean = false): boolean {
        switch (this.timerStatus) {
            case WinAnimatorExtended.ShowFirstWinsStep1:
                this.runCounterOutro();
                break;
            case WinAnimatorExtended.ShowFirstWinsStep2:
            case WinAnimatorExtended.ShowFirstWinsStep3:
                this.runCounterStep3();
                break;
        }

        if (!Utils.isNullOrUndefined(this.currentCounterStep)) {
            this.currentCounterStep = null;

            this.runCounterOutro();
        }

        return super.reset(showLastSymbols, spin);
    }

    //******************************************************************************************************************
    //  TIMER
    //******************************************************************************************************************

    protected onTimerComplete(): void {
        super.onTimerComplete();

        switch (this.timerStatus) {
            case WinAnimatorExtended.ShowFirstWinsStep1:
                this.showFirstWinsStep1();
                break;
            case WinAnimatorExtended.ShowFirstWinsStep2:
                this.showFirstWinsStep2();
                break;
            case WinAnimatorExtended.ShowFirstWinsStep3:
                this.showFirstWinsStep3();
                break;
            case WinAnimatorExtended.ShowFirstWinsStep4:
                this.showFirstWinsStep4();
                break;
            case WinAnimatorExtended.ShowFirstWins:
                this.showFirstWins();
                break;
            case WinAnimatorExtended.CycleWins1:
                this.cycleCashWins();
                break;
            case WinAnimatorExtended.StartAnimationTimer:
                this.startAnimation();
                break;
            case WinAnimatorExtended.FinishWinAnimatorTimer:
                this.emit(WinAnimator.FinishWinAnimator);
                break;
            case WinAnimatorExtended.MysteryDrawTimer:
                this.mysteryDraw();
                break;
            case WinAnimatorExtended.BigXDrawTimer:
                this.bigXDraw();
                break;
        }
    }

    //******************************************************************************************************************
    //  SYMBOLS
    //******************************************************************************************************************

    protected addCurrentSymbol(reelIndex: number, symbolIndex: number): void {
        if (this.currentStickySymbols[reelIndex][symbolIndex] == null) {
            if (this.currentSymbols[reelIndex][symbolIndex] === null) {
                const id = this.currentReels[reelIndex].symbols[symbolIndex];
                const symbol = this.symbols.getSymbol(id - 1, CustomUtils.getCase(id, Symbol.CaseNormal));
                symbol.position.x = this.reelX[reelIndex] - symbol.offsetX;
                symbol.position.y = this.reelY[reelIndex] + this.symbolHeight * symbolIndex - symbol.offsetY;

                this.symbolsContainer.addChild(symbol);

                this.currentSymbols[reelIndex][symbolIndex] = symbol;
            }
        }
    }

    protected allSymbolsGoToCase(caseType: string, noWin: boolean): void {
        for (let i = 0; i < this.currentSymbols.length; i++) {
            for (let j = 0; j < this.currentSymbols[i].length; j++) {
                const symbol = this.currentSymbols[i][j];

                if (symbol !== null) {
                    let caseTypeNew = caseType;
                    if (caseType == Symbol.CaseNowin) {
                        caseTypeNew = CustomUtils.getCase(symbol.id, Symbol.CaseNowin);
                    } else if (caseType == Symbol.CaseNormal) {
                        caseTypeNew = CustomUtils.getCase(symbol.id, Symbol.CaseNormal);
                    }

                    if (this.allowSymbolGoToCase(i, j, caseTypeNew)) {
                        symbol.goToCase(caseTypeNew);

                        if (noWin) {
                            this.noWinSymbolsContainer.addChild(symbol);
                        } else {
                            this.symbolsContainer.addChild(symbol);
                        }
                    }
                }
            }
        }
    }

    protected winSymbolsGoToCaseAsPayline(winIndex: number, caseType: string): Array<Symbol> {
        const win = this.currentWins[winIndex];
        const symbols: Array<Symbol> = [];

        if (this.paylines != null) {
            const definition = PaylinesDefinitions.getPaylineDefinitionsById(
                win.paylineId,
                this.paylines.paylineDefinition,
            );

            for (let i = 0; i < definition.length; i++) {
                if (win.mask[i] === 1 && this.allowSymbolGoToCase(i, definition[i], caseType)) {
                    const symbol = this.currentSymbols[i][definition[i]];
                    if (caseType === Symbol.CaseCycle) {
                        if (this.currentWins.length > 1) {
                            symbol.goToCase(Symbol.CaseCycle);
                        } else {
                            symbol.goToCase(Symbol.CaseSingleWin);
                        }
                    } else {
                        symbol.goToCase(caseType);
                    }

                    this.symbolsContainer.addChild(symbol);

                    symbols.push(symbol);
                } else {
                    const symbol = this.currentSymbols[i][definition[i]];
                    if (caseType === Symbol.CaseCycle) {
                        if (this.currentWins.length > 1) {
                            symbol.goToCase("CYCLE_NOWIN");
                        } else {
                            symbol.goToCase("SINGLE_NOWIN");
                        }
                    }
                }
            }
        }

        return symbols;
    }

    protected winSymbolsGoToCaseAsScatter(winIndex: number, caseType: string): Array<Symbol> {
        const win = this.currentWins[winIndex];
        const symbols: Array<Symbol> = [];

        for (let i = 0; i < this.reelCount; i++) {
            for (let j = 0; j < this.symbolCount; j++) {
                if (CustomUtils.isWinOnPosition(win, i, j) && this.allowSymbolGoToCase(i, j, caseType)) {
                    const symbol = this.currentSymbols[i][j];
                    if (caseType === Symbol.CaseCycle) {
                        symbol.goToCase(Symbol.CaseCycle);
                    } else {
                        symbol.goToCase(caseType);
                    }

                    this.symbolsContainer.addChild(symbol);

                    symbols.push(symbol);
                }
            }
        }

        return symbols;
    }

    protected allowSymbolGoToCase(reelIndex: number, symbolIndex: number, caseType: string): boolean {
        if (
            this.currentSymbols[reelIndex][symbolIndex].getCurrentCase() === Symbol.CaseIdle &&
            caseType === Symbol.CaseNormal
        ) {
            return false;
        }

        return true;
    }

    protected winPaylineGoToCase(winIndex: number, caseType: string): void {
        if (this.paylines != null) {
            const win = this.currentWins[winIndex];

            if (win.trigger === Communication.Game.WinTrigger.Payline) {
                if (caseType === Payline.CaseWin && this.currentWins.length === 1) {
                    this.paylines.goToCase(Payline.CaseSingleWin, win.paylineId);

                    if (win.payoutId < Settings.SymbolBigXSpins) {
                        BaseView.paytableBoxElement.chooseMultiplier(win.payoutId - 1);
                        BaseView.paytableBoxElement.chooseSymbol(win.payoutId - 1);
                    }

                    if (!Utils.isNullOrUndefined(this.reelsContaier)) {
                        const reel_1: SwitchElement = this.reelsContaier.getChildElementByName(
                            "Reel1",
                        ) as SwitchElement;
                        const reel_2: SwitchElement = this.reelsContaier.getChildElementByName(
                            "Reel2",
                        ) as SwitchElement;
                        const reel_3: SwitchElement = this.reelsContaier.getChildElementByName(
                            "Reel3",
                        ) as SwitchElement;

                        const definition = PaylinesDefinitions.getPaylineDefinitionsById(
                            win.paylineId,
                            this.paylines.paylineDefinition,
                        );

                        if (!Utils.isNullOrUndefined(reel_1)) {
                            reel_1.goToCase("WIN");
                            let reelWinSlot = reel_1.getChildElementByName(
                                "ReelWinSlot" + (definition[0] + 1),
                            ) as ImageElement;
                            if (!Utils.isNullOrUndefined(reelWinSlot)) {
                                reelWinSlot.visible = true;
                                Tweens.removeTweens(reelWinSlot, "all");
                                Tweens.customTween(reelWinSlot, {
                                    tween: "alpha",
                                    tweenValues: [0, 0.5, 0.5, 0, 0],
                                    tweenDuration: [2, 13, 2, 13],
                                    tweenLoop: false,
                                });
                            }
                        }
                        if (!Utils.isNullOrUndefined(reel_2)) {
                            reel_2.goToCase("WIN");
                            let reelWinSlot = reel_2.getChildElementByName(
                                "ReelWinSlot" + (definition[1] + 1),
                            ) as ImageElement;
                            if (!Utils.isNullOrUndefined(reelWinSlot)) {
                                reelWinSlot.visible = true;
                                Tweens.removeTweens(reelWinSlot, "all");
                                Tweens.customTween(reelWinSlot, {
                                    tween: "alpha",
                                    tweenValues: [0, 0.5, 0.5, 0, 0],
                                    tweenDuration: [2, 13, 2, 13],
                                    tweenLoop: false,
                                });
                            }
                        }
                        if (!Utils.isNullOrUndefined(reel_3)) {
                            reel_3.goToCase("WIN");
                            let reelWinSlot = reel_3.getChildElementByName(
                                "ReelWinSlot" + (definition[2] + 1),
                            ) as ImageElement;
                            if (!Utils.isNullOrUndefined(reelWinSlot)) {
                                reelWinSlot.visible = true;
                                Tweens.removeTweens(reelWinSlot, "all");
                                Tweens.customTween(reelWinSlot, {
                                    tween: "alpha",
                                    tweenValues: [0, 0.5, 0.5, 0, 0],
                                    tweenDuration: [2, 13, 2, 13],
                                    tweenLoop: false,
                                });
                            }
                        }
                    }
                } else {
                    this.paylines.goToCase(caseType, win.paylineId);

                    if (!Utils.isNullOrUndefined(this.reelsContaier)) {
                        const reel_1: SwitchElement = this.reelsContaier.getChildElementByName(
                            "Reel1",
                        ) as SwitchElement;
                        const reel_2: SwitchElement = this.reelsContaier.getChildElementByName(
                            "Reel2",
                        ) as SwitchElement;
                        const reel_3: SwitchElement = this.reelsContaier.getChildElementByName(
                            "Reel3",
                        ) as SwitchElement;

                        if (caseType == Payline.CaseFirstWin || caseType == Payline.CaseWin) {
                            if (win.payoutId < Settings.SymbolBigXSpins) {
                                BaseView.paytableBoxElement.chooseMultiplier(win.payoutId - 1);
                                BaseView.paytableBoxElement.chooseSymbol(win.payoutId - 1);
                            }

                            const definition = PaylinesDefinitions.getPaylineDefinitionsById(
                                win.paylineId,
                                this.paylines.paylineDefinition,
                            );
                            if (!Utils.isNullOrUndefined(reel_1)) {
                                reel_1.goToCase("WIN");
                                let reelWinSlot = reel_1.getChildElementByName(
                                    "ReelWinSlot" + (definition[0] + 1),
                                ) as ImageElement;
                                if (!Utils.isNullOrUndefined(reelWinSlot)) {
                                    reelWinSlot.visible = true;
                                    Tweens.removeTweens(reelWinSlot, "all");
                                    Tweens.customTween(reelWinSlot, {
                                        tween: "alpha",
                                        tweenValues: [0, 0.5, 0.5, 0, 0],
                                        tweenDuration: [2, 13, 2, 13],
                                        tweenLoop: false,
                                    });
                                }
                            }
                            if (!Utils.isNullOrUndefined(reel_2)) {
                                reel_2.goToCase("WIN");
                                let reelWinSlot = reel_2.getChildElementByName(
                                    "ReelWinSlot" + (definition[1] + 1),
                                ) as ImageElement;
                                if (!Utils.isNullOrUndefined(reelWinSlot)) {
                                    reelWinSlot.visible = true;
                                    Tweens.removeTweens(reelWinSlot, "all");
                                    Tweens.customTween(reelWinSlot, {
                                        tween: "alpha",
                                        tweenValues: [0, 0.5, 0.5, 0, 0],
                                        tweenDuration: [2, 13, 2, 13],
                                        tweenLoop: false,
                                    });
                                }
                            }
                            if (!Utils.isNullOrUndefined(reel_3)) {
                                reel_3.goToCase("WIN");
                                let reelWinSlot = reel_3.getChildElementByName(
                                    "ReelWinSlot" + (definition[2] + 1),
                                ) as ImageElement;
                                if (!Utils.isNullOrUndefined(reelWinSlot)) {
                                    reelWinSlot.visible = true;
                                    Tweens.removeTweens(reelWinSlot, "all");
                                    Tweens.customTween(reelWinSlot, {
                                        tween: "alpha",
                                        tweenValues: [0, 0.5, 0.5, 0, 0],
                                        tweenDuration: [2, 13, 2, 13],
                                        tweenLoop: false,
                                    });
                                }
                            }
                        } else if (caseType == Payline.CaseCycle) {
                            if (win.payoutId < Settings.SymbolBigXSpins) {
                                BaseView.paytableBoxElement.reset({
                                    symbolsOn: false,
                                    symbolsNoWinOn: true,
                                    symbolsGlowOff: true,
                                    multipliersGlowOff: true,
                                });
                                BaseView.paytableBoxElement.chooseSymbol(win.payoutId - 1);
                                BaseView.paytableBoxElement.chooseMultiplier(win.payoutId - 1);
                            }

                            const definition = PaylinesDefinitions.getPaylineDefinitionsById(
                                win.paylineId,
                                this.paylines.paylineDefinition,
                            );
                            if (!Utils.isNullOrUndefined(reel_1)) {
                                reel_1.goToCase("CYCLE");
                                let reelWinSlot = reel_1.getChildElementByName(
                                    "ReelWinSlot" + (definition[0] + 1),
                                ) as ImageElement;
                                if (!Utils.isNullOrUndefined(reelWinSlot)) {
                                    reelWinSlot.visible = true;
                                    Tweens.removeTweens(reelWinSlot, "all");
                                    Tweens.customTween(reelWinSlot, {
                                        tween: "alpha",
                                        tweenValues: [0, 0.5, 0.5, 0, 0],
                                        tweenDuration: [2, 13, 2, 13],
                                        tweenLoop: true,
                                    });
                                }
                            }
                            if (!Utils.isNullOrUndefined(reel_2)) {
                                reel_2.goToCase("CYCLE");
                                let reelWinSlot = reel_2.getChildElementByName(
                                    "ReelWinSlot" + (definition[1] + 1),
                                ) as ImageElement;
                                if (!Utils.isNullOrUndefined(reelWinSlot)) {
                                    reelWinSlot.visible = true;
                                    Tweens.removeTweens(reelWinSlot, "all");
                                    Tweens.customTween(reelWinSlot, {
                                        tween: "alpha",
                                        tweenValues: [0, 0.5, 0.5, 0, 0],
                                        tweenDuration: [2, 13, 2, 13],
                                        tweenLoop: true,
                                    });
                                }
                            }
                            if (!Utils.isNullOrUndefined(reel_3)) {
                                reel_3.goToCase("CYCLE");
                                let reelWinSlot = reel_3.getChildElementByName(
                                    "ReelWinSlot" + (definition[2] + 1),
                                ) as ImageElement;
                                if (!Utils.isNullOrUndefined(reelWinSlot)) {
                                    reelWinSlot.visible = true;
                                    Tweens.removeTweens(reelWinSlot, "all");
                                    Tweens.customTween(reelWinSlot, {
                                        tween: "alpha",
                                        tweenValues: [0, 0.5, 0.5, 0, 0],
                                        tweenDuration: [2, 13, 2, 13],
                                        tweenLoop: true,
                                    });
                                }
                            }
                        } else if (caseType == Payline.CaseNormal) {
                            if (!Utils.isNullOrUndefined(reel_1)) {
                                reel_1.goToCase("NORMAL");
                            }
                            if (!Utils.isNullOrUndefined(reel_2)) {
                                reel_2.goToCase("NORMAL");
                            }
                            if (!Utils.isNullOrUndefined(reel_3)) {
                                reel_3.goToCase("NORMAL");
                            }
                        }
                    }
                }
            } else if (win.trigger === Communication.Game.WinTrigger.Scatter) {
                if (caseType === Payline.CaseFirstWin && this.currentWins.length === 1) {
                    this.highlightPositionsOnReels("WIN", ReelsHighlightOptions.show_slow);
                } else if (caseType === Payline.CaseWin && this.currentWins.length > 1) {
                    this.highlightPositionsOnReels("WIN", ReelsHighlightOptions.show_slow);
                } else if (caseType === Payline.CaseCycle) {
                    if (win.payoutId == Settings.SymbolMystery) {
                        this.highlightPositionsOnReels("WIN", ReelsHighlightOptions.loop);
                        if (GameManager.baseResponse != null && GameManager.baseResponse.hasOwnProperty("customData")) {
                            if (GameManager.baseResponse.customData.hasOwnProperty("mysterySymbol")) {
                                let mysterySymbol = GameManager.baseResponse.customData.mysterySymbol;
                                BaseView.paytableBoxElement.reset({
                                    symbolsOn: false,
                                    symbolsNoWinOn: true,
                                    symbolsGlowOff: true,
                                    multipliersGlowOff: true,
                                });
                                BaseView.paytableBoxElement.chooseSymbol(mysterySymbol - 1);
                                BaseView.paytableBoxElement.chooseMultiplier(mysterySymbol - 1);
                            }
                        }
                    }
                }
            }
        }
    }

    //******************************************************************************************************************
    //  IDLE
    //******************************************************************************************************************

    protected idle(): void {
        if (StageController.baseStage) {
            if (!Utils.isNullOrUndefined(BaseView.paytableBoxElement)) {
                BaseView.paytableBoxElement.idle();
            }

            /* if (this._spinButton != null && !this._spinButton.classList.contains('idle')) {
                 this._spinButton.classList.add('idle');
             }*/
        }

        this.startTimer(WinAnimator.Idle, this.getIdleDelay());
    }

    protected getInitialIdleDelay(): number {
        return 240;
    }

    protected getIdleDelay(): number {
        return 60;
    }

    protected getIdleActiveElementsCount(): number {
        return 2;
    }

    public hasMysteryWin(currentWins: IWin[]): boolean {
        let hasMysteryWin = false;

        if (currentWins != null) {
            for (let i = 0; i < currentWins.length; i++) {
                if (currentWins[i].trigger === Communication.Game.WinTrigger.Scatter) {
                    if (currentWins[i].type.toString() == "mystery") {
                        hasMysteryWin = true;
                    }
                }
            }
        }

        return hasMysteryWin;
    }

    public hasCashWin(currentWins: IWin[]): boolean {
        let hasCashWin = false;

        if (currentWins != null) {
            for (let i = 0; i < currentWins.length; i++) {
                if (currentWins[i].trigger === Communication.Game.WinTrigger.Payline) {
                    if (currentWins[i].type == Communication.Game.WinType.Cash) {
                        hasCashWin = true;
                    }
                } else if (currentWins[i].trigger === Communication.Game.WinTrigger.Scatter) {
                    if (currentWins[i].type == Communication.Game.WinType.Cash) {
                        hasCashWin = true;
                    }
                }
            }
        }

        return hasCashWin;
    }

    public hasBigXWin(): boolean {
        return CustomUtils.isRespinLast();
    }

    /**
     *
     * @param {Object} element
     */
    public addElementInstance(element: Object): void {
        this.elementInstance[Object.keys(element)[0]] = element[Object.keys(element)[0]];
    }

    //******************************************************************************************************************
    //  BIGX FEATURE
    //******************************************************************************************************************

    public stickScatterSymbols(baseResponseData: Communication.Game.GameModuleBaseResponse, init = false): number {
        let reelsData: Array<Communication.Game.IReel> = baseResponseData.screen.reels;
        let stickCounter = 0;

        if (Utils.isNullOrUndefined(this.currentStickySymbols)) {
            this.currentStickySymbols = [];
        }

        for (let reelIndex = 0; reelIndex < reelsData.length; reelIndex++) {
            if (Utils.isNullOrUndefined(this.currentStickySymbols[reelIndex])) {
                this.currentStickySymbols[reelIndex] = [];
            }

            if (init) {
                if (reelsData[reelIndex].hasOwnProperty("overlay")) {
                    for (let symbolIndex = 0; symbolIndex < reelsData[reelIndex].overlay.length; symbolIndex++) {
                        if (reelsData[reelIndex].overlay[symbolIndex] === Settings.SymbolBigXSpins) {
                            if (this.currentStickySymbols[reelIndex][symbolIndex] == null) {
                                const currentSymbol = this.currentSymbols[reelIndex][symbolIndex];
                                currentSymbol.goToCase("EMPTY");

                                const stickySymbol = this.symbols.getSymbol(Settings.SymbolBigXSpins - 1, "STICK");
                                stickySymbol.position.x = currentSymbol.position.x;
                                stickySymbol.position.y = currentSymbol.position.y;
                                this.currentStickySymbols[reelIndex][symbolIndex] = stickySymbol;
                                this.stickyContainer.addChild(stickySymbol);
                                stickCounter++;
                            }
                        }
                    }
                }
            } else {
                if (reelsData[reelIndex].hasOwnProperty("overlay")) {
                    for (let symbolIndex = 0; symbolIndex < reelsData[reelIndex].overlay.length; symbolIndex++) {
                        if (reelsData[reelIndex].overlay[symbolIndex] === Settings.SymbolBigXSpins) {
                            if (this.currentStickySymbols[reelIndex][symbolIndex] == null) {
                                const currentSymbol = this.currentSymbols[reelIndex][symbolIndex];
                                currentSymbol.goToCase("EMPTY");

                                let caseName: string;
                                if (reelIndex == 1 && symbolIndex == 1) {
                                    caseName = "STICK_FIRST";
                                } else {
                                    caseName = "STICK";
                                }

                                const stickySymbol = this.symbols.getSymbol(Settings.SymbolBigXSpins - 1, caseName);
                                stickySymbol.position.x = currentSymbol.position.x;
                                stickySymbol.position.y = currentSymbol.position.y;
                                this.currentStickySymbols[reelIndex][symbolIndex] = stickySymbol;
                                this.stickyContainer.addChild(stickySymbol);
                                stickCounter++;
                            }
                        }
                    }
                }
            }
        }

        return stickCounter;
    }

    public removeScattersSymbols() {
        if (this.currentStickySymbols != null) {
            for (let reelIndex = 0; reelIndex < this.reelCount; reelIndex++) {
                for (let symbolIndex = 0; symbolIndex < this.symbolCount; symbolIndex++) {
                    if (
                        this.currentStickySymbols[reelIndex] != null &&
                        this.currentStickySymbols[reelIndex][symbolIndex] != null
                    ) {
                        this.symbols.returnSymbol(this.currentStickySymbols[reelIndex][symbolIndex]);
                        this.currentStickySymbols[reelIndex][symbolIndex] = null;
                    }
                }
            }
        }
    }

    public switchScattersSymbolsToCurrentSymbols(caseType?: string) {
        if (this.currentStickySymbols != null) {
            for (let reelIndex = 0; reelIndex < this.reelCount; reelIndex++) {
                for (let symbolIndex = 0; symbolIndex < this.symbolCount; symbolIndex++) {
                    if (
                        this.currentStickySymbols[reelIndex] != null &&
                        this.currentStickySymbols[reelIndex][symbolIndex] != null
                    ) {
                        this.symbols.returnSymbol(this.currentSymbols[reelIndex][symbolIndex]);
                        this.currentSymbols[reelIndex][symbolIndex] = this.currentStickySymbols[reelIndex][symbolIndex];
                        this.currentStickySymbols[reelIndex][symbolIndex] = null;
                        this.symbolsContainer.addChild(this.currentSymbols[reelIndex][symbolIndex]);

                        if (caseType != null) {
                            this.currentSymbols[reelIndex][symbolIndex].goToCase(caseType);
                        }
                    }
                }
            }
        }
    }

    //******************************************************************************************************************
    //  COUNTER
    //******************************************************************************************************************

    protected createCounter(): void {
        this.counter = this.childs["Counter"];

        if (!Utils.isNullOrUndefined(this.counter)) {
            this.winCounter = this.counter.childs["WinCounter"];

            this.animationsContainer.addChild(this.counter);
        }
    }

    protected resetCounter(): void {
        Tweens.removeTweens(this.counter, "all");

        this.counter.alpha = 0;
    }

    protected runCounterStep1(): void {
        if (this.currentWins[this.currentCounterStep] != null) {
            if (this.currentWins[this.currentCounterStep].paylineId <= 5) {
                PlayList.play("SND_BaseWin" + this.currentWins[this.currentCounterStep].paylineId);
            }
        }

        let amountFrom = "0";
        let amountTo = "0";

        for (let i = 0; i <= this.currentCounterStep; i++) {
            const win = this.currentWins[i];

            if (win.type === Communication.Game.WinType.Cash) {
                if (i < this.currentCounterStep) {
                    amountFrom = NumberUtils.add(amountFrom, win.amount);
                }

                amountTo = NumberUtils.add(amountTo, win.amount);
            }
        }

        if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
            ImageTextCounterElement.Round = true;
            this.winCounter.start(
                parseInt(NumberUtils.devide(amountFrom, BetManager.CoinSize).toString()),
                parseInt(NumberUtils.devide(amountTo, BetManager.CoinSize).toString()),
                0,
            );
        } else {
            ImageTextCounterElement.Round = false;
            this.winCounter.start(parseFloat(amountFrom), parseFloat(amountTo), 0);
        }

        const step = (0.8 - 0.5) / this.currentWins.length;

        Tweens.removeTweens(this.counter, "all");
        Tweens.alphaTween(this.counter, {
            alphas: [this.counter.alpha, 1],
            tweenDuration: 20,
        });
        Tweens.scaleTween(this.counter, {
            tweenValues: [
                new PIXI.Point(0.5 + step * this.currentCounterStep, 0.5 + step * this.currentCounterStep),
                new PIXI.Point(0.5 + step * (this.currentCounterStep + 1), 0.5 + step * (this.currentCounterStep + 1)),
            ],
            tweenDuration: 20,
            tweenEase: "backInOut",
        });
    }

    protected runBonusCounterStep1(): void {
        let currentCounterStep = Math.floor(this.currentCounterStep);
        if (this.currentWins[currentCounterStep] != null) {
            if (this.currentWins[currentCounterStep].paylineId <= 5) {
                PlayList.play("SND_BaseWin" + this.currentWins[currentCounterStep].paylineId);
            }
        }

        let amountTo = "0";

        if (!Utils.isNullOrUndefined(BaseView.Logo)) {
            let numberElement = BaseView.Logo.getChildElementByName("SpinsBoxNumber") as ImageTextElement;
            if (!Utils.isNullOrUndefined(numberElement)) {
                numberElement.setText(amountTo);

                const step = (0.8 - 0.5) / this.currentWins.length;

                Tweens.removeTweens(numberElement, "all");
                Tweens.alphaTween(numberElement, {
                    alphas: [0, 1, 0, 1],
                    tweenDuration: 15,
                    tweenLoop: false,
                });
            }
        }
    }

    protected runCounterStep2(): void {
        PlayList.play("SND_BaseCreditboxEnd");

        Tweens.removeTweens(this.counter, "all");
        Tweens.scaleTween(this.counter, {
            tweenValues: [new PIXI.Point(0.8, 0.8), new PIXI.Point(1, 1), new PIXI.Point(0.8, 0.8)],
            tweenDuration: 30,
        });
    }

    protected runCounterStep3(): void {
        Tweens.removeTweens(this.counter, "all");
        Tweens.alphaTween(this.counter, {
            alphas: [1, 0],
            tweenDuration: 30,
        });
        Tweens.scaleTween(this.counter, {
            tweenValues: [new PIXI.Point(0.8, 0.8), new PIXI.Point(1.8, 1.8)],
            tweenDuration: 30,
        });
    }

    protected runCounterOutro(): void {
        PlayList.play("SND_BaseCreditboxEnd");

        if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
            ImageTextCounterElement.Round = true;
            this.winCounter.start(0, parseInt(NumberUtils.devide(this.currentWin, BetManager.CoinSize).toString()), 0);
        } else {
            ImageTextCounterElement.Round = false;
            this.winCounter.start(0, this.currentWin, 0);
        }

        Tweens.removeTweens(this.counter, "all");
        Tweens.alphaTween(this.counter, {
            alphas: [1, 0],
            tweenDuration: 20,
            tweenDelay: 20,
        });
        Tweens.scaleTween(this.counter, {
            tweenValues: [new PIXI.Point(0.8, 0.8), new PIXI.Point(1.8, 1.8)],
            tweenDuration: 20,
            tweenDelay: 20,
        });
    }

    /**
     * Method called before draw in paytable box.
     */
    public addEldoradoSpinsSymbolsToWinCase() {
        for (let i = 0; i < this.currentWins.length; i++) {
            this.winSymbolsGoToCase(i, Symbol.CaseNormal, false);

            this.winPaylineGoToCase(i, Payline.CaseNormal);
            this.winSymbolsGoToCase(i, Symbol.CaseQuickWin, false);
        }
    }

    /**
     *
     */
    public addMysterySymbolsToWinCase() {
        for (let i = 0; i < this.currentWins.length; i++) {
            if (this.isMysteryWin(this.currentWins[i])) {
                this.winSymbolsGoToCase(i, Symbol.CaseNormal, false);
                this.winSymbolsGoToCase(i, Symbol.CaseWin, false);
            }
        }
    }

    /**
     *
     * @param reelToCase
     * @param options
     *
     * loop - highlight in loop
     * show_slow - highlight with tween, no loop
     * show_fast - highlight, with visible = true
     * hide - turn off highlight vith visible = false
     */
    public highlightPositionsOnReels(reelToCase: string, highlightOptions: ReelsHighlightOptions) {
        let currentMysteryWin: Communication.Game.IWin = null;
        if (this.currentWins != null) {
            for (let i = 0; i < this.currentWins.length; i++) {
                if (this.isMysteryWin(this.currentWins[i])) {
                    currentMysteryWin = this.currentWins[i];
                }
            }
        }

        if (!Utils.isNullOrUndefined(currentMysteryWin)) {
            for (let i = 0; i < this.reelCount; i++) {
                for (let j = 0; j < this.symbolCount; j++) {
                    if (CustomUtils.isWinOnPosition(currentMysteryWin, i, j)) {
                        if (!Utils.isNullOrUndefined(BaseView.Reels)) {
                            let reel = BaseView.Reels.getChildElementByName("Reel" + (i + 1)) as SwitchElement;
                            if (!Utils.isNullOrUndefined(reel)) {
                                reel.goToCase(reelToCase);

                                let reelWinSlot = reel.getChildElementByName("ReelWinSlot" + (j + 1)) as ImageElement;

                                if (highlightOptions == ReelsHighlightOptions.loop) {
                                    reelWinSlot.visible = true;
                                    Tweens.removeTweens(reelWinSlot, "all");
                                    Tweens.customTween(reelWinSlot, {
                                        tween: "alpha",
                                        tweenValues: [0, 0.5, 0.5, 0, 0],
                                        tweenDuration: [2, 13, 2, 13],
                                        tweenLoop: true,
                                    });
                                } else if (highlightOptions == ReelsHighlightOptions.show_slow) {
                                    reelWinSlot.visible = true;
                                    Tweens.removeTweens(reelWinSlot, "all");
                                    Tweens.customTween(reelWinSlot, {
                                        tween: "alpha",
                                        tweenValues: [0, 0.5, 0.5, 0, 0],
                                        tweenDuration: [2, 13, 2, 13],
                                        tweenLoop: false,
                                    });
                                } else if (highlightOptions == ReelsHighlightOptions.show_fast) {
                                    reelWinSlot.visible = true;
                                    Tweens.removeTweens(reelWinSlot, "all");
                                    reelWinSlot.alpha = 1;
                                } else if (highlightOptions == ReelsHighlightOptions.hide) {
                                    reelWinSlot.visible = false;
                                    Tweens.removeTweens(reelWinSlot, "all");
                                    reelWinSlot.alpha = 1;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    /**
     *
     * @param reelIndex
     * @param reelToCase
     * @param highlightOptions
     */
    public highlightReel(reelIndex: number, reelToCase: string, highlightOptions: ReelsHighlightOptions) {
        let i = reelIndex;
        let reel: SwitchElement;

        if (!Utils.isNullOrUndefined(BaseView.Reels)) {
            reel = BaseView.Reels.getChildElementByName("Reel" + (i + 1)) as SwitchElement;
            if (!Utils.isNullOrUndefined(reel)) {
                reel.goToCase(reelToCase);
            }
        }

        for (let j = 0; j < this.symbolCount; j++) {
            if (!Utils.isNullOrUndefined(reel)) {
                let reelWinSlot = reel.getChildElementByName("ReelWinSlot" + (j + 1)) as ImageElement;

                if (highlightOptions == ReelsHighlightOptions.loop) {
                    reelWinSlot.visible = true;
                    Tweens.removeTweens(reelWinSlot, "all");
                    Tweens.customTween(reelWinSlot, {
                        tween: "alpha",
                        tweenValues: [0, 0.5, 0.5, 0, 0],
                        tweenDuration: [2, 13, 2, 13],
                        tweenLoop: true,
                    });
                } else if (highlightOptions == ReelsHighlightOptions.show_slow) {
                    reelWinSlot.visible = true;
                    Tweens.removeTweens(reelWinSlot, "all");
                    Tweens.customTween(reelWinSlot, {
                        tween: "alpha",
                        tweenValues: [0, 0.5, 0.5, 0, 0],
                        tweenDuration: [2, 13, 2, 13],
                        tweenLoop: false,
                    });
                } else if (highlightOptions == ReelsHighlightOptions.show_fast) {
                    reelWinSlot.visible = true;
                    Tweens.removeTweens(reelWinSlot, "all");
                    reelWinSlot.alpha = 1;
                } else if (highlightOptions == ReelsHighlightOptions.hide) {
                    reelWinSlot.visible = false;
                    Tweens.removeTweens(reelWinSlot, "all");
                    reelWinSlot.alpha = 1;
                }
            }
        }
    }

    /**
     *
     * @param currentWin
     */
    public isMysteryWin(currentWin: Communication.Game.IWin): boolean {
        if (currentWin.trigger === Communication.Game.WinTrigger.Scatter) {
            if (currentWin.type.toString() == "mystery") {
                return true;
            }
        }

        return false;
    }

    /**
     *
     */
    protected startAnimation(): void {
        if (CustomUtils.isRespinLast()) {
            this.currentAnimationIndex = this.animationNames.indexOf("WinRespin");
        } else {
            this.currentAnimationIndex = this.getAnimationIndex();
        }

        this.currentAnimationFinished = false;

        const animation = this.animations[this.currentAnimationIndex];
        animation.visible = true;

        if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
            ImageTextCounterElement.Round = true;
            animation.play(parseInt(NumberUtils.devide(this.currentWin, BetManager.CoinSize).toString()));
        } else {
            ImageTextCounterElement.Round = false;
            animation.play(this.currentWin);
        }
    }

    public showWinAnimationFrame(frameNumber: number): void {
        if (CustomUtils.isRespinLast()) {
            this.currentAnimationIndex = this.animationNames.indexOf("WinRespin");
            this.currentAnimationFinished = false;

            const animation = this.animations[this.currentAnimationIndex];
            animation.visible = true;

            if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
                ImageTextCounterElement.Round = true;
                animation.winValue = parseInt(NumberUtils.devide(this.currentWin, BetManager.CoinSize).toString());
                animation.goToFrame(frameNumber);
            } else {
                ImageTextCounterElement.Round = false;
                animation.winValue = this.currentWin;
                animation.goToFrame(frameNumber);
            }
        }
    }

    protected onAnimationComplete(): void {
        if (!CustomUtils.isRespinLast()) {
            this.currentAnimationIndex = null;
        }
        this.currentMultiplierIndex = -1;

        this.finishFirstWins();
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/WinAnimatorExtended.ts
 **/